import { baseUrl, handleResponse, handleError, PutOptions, GetHeaders } from "../common/ApiUtils";

const apiUrl = baseUrl + "Options/IssueGroup";

export function createIssueGroup(issueGroup) {
    return fetch(`${apiUrl}/Create`, PutOptions(issueGroup)).then(handleResponse).catch(handleError);
}

export function updateIssueGroup(groupId, issueGroup) {
    return fetch(`${apiUrl}/${groupId}/Update`, PutOptions(issueGroup)).then(handleResponse).catch(handleError);
}

export function getIssueGroupWithOptions(issueGroupId) {
    const result = fetch(`${apiUrl}/GetWithOptions/${issueGroupId}`, GetHeaders()).then(handleResponse).catch(handleError);
    return result;
}

export function getIssueGroup(issueGroupId) {
    const result = fetch(`${apiUrl}/Get/${issueGroupId}`, GetHeaders()).then(handleResponse).catch(handleError);
    return result;
}